<script setup lang="ts">
import { ModalV2Layout } from '@teachino/shared-design-system';
import { $t } from '@teachino/shared-i18n';
import { useGlobalDependencyProvider } from '@teachino/shared-util';
import { onMounted } from 'vue';
import type { UpgradePromptModalProps } from './open-upgrade-prompt-modal';
import UpsellFeatureBanner from './UpsellFeatureBanner.vue';

const props = defineProps<UpgradePromptModalProps>();

const di = useGlobalDependencyProvider();
const analytics = di.inject('analytics');
const router = di.inject('router');

onMounted(() => {
  analytics.track('upgrade-open-dialog', { source: props.source });
});

function handleUpgrade(): void {
  props.resolve({ value: undefined, cancelled: false });
  router.upgrade();
}
</script>

<template>
  <ModalV2Layout>
    <template #content>
      <UpsellFeatureBanner
        embedded
        action-layout="stacked"
        :action-label="$t('upgrade.plan.cta')"
        :source="props.source"
        :upgrade-handler="handleUpgrade"
      />
    </template>
  </ModalV2Layout>
</template>
